import React from "react";
import PropTypes from "prop-types";
import { Box, Paper, MobileStepper } from "@mui/material";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { useStyles } from "./Styles";

const propTypes = {
  activeStep: PropTypes.number.isRequired,
  steps: PropTypes.number.isRequired,
  disableNext: PropTypes.number.isRequired,
  handleStep: PropTypes.func.isRequired,
  variant: PropTypes.string.isRequired,
};

BottomNavigation.prototype = propTypes;
export default function BottomNavigation(props) {
  const styles = useStyles();
  return (
    <Paper
      className="notifications-stepper"
      elevation={0}
      sx={{
        position: "fixed",
        bottom: 0,
        borderRadius: 0,
      }}
    >
      <Box
        sx={{
          display: "-webkit-inline-flex",
          pl: 7,
        }}
      >
        {props.variant == "dots" && (
          <MobileStepper
            variant={props.variant}
            p={0}
            steps={props.steps}
            position="static"
            activeStep={props.activeStep}
            backButton={
              <Box
                as="button"
                onClick={() => {
                  props.handleStep(props.activeStep - 1);
                }}
                disabled={props.activeStep == 0}
              >
                <MdChevronLeft className={styles.chevronBtnIcon} />
              </Box>
            }
            nextButton={
              <Box
                as="button"
                onClick={() => {
                  props.handleStep(props.activeStep + 1);
                }}
                disabled={props.activeStep == props.disableNext}
              >
                <MdChevronRight className={styles.chevronBtnIcon} />
              </Box>
            }
          />
        )}
      </Box>
    </Paper>
  );
}
